export const GetTimeAgo = (time) => {
    const currentTime = new Date();
    const commentTime = new Date(time);
    const timeDifference = Math.abs(currentTime.getTime() - commentTime.getTime());

    const minuteDifference = Math.floor(timeDifference / (1000 * 60));
    const isSameDay = currentTime.toDateString() === commentTime.toDateString();
    
    const formatTime = (date) => {
        return date.toLocaleTimeString([], { hour: '2-digit', minute: '2-digit' });
    };

    if (minuteDifference < 60) {
        return `${formatTime(commentTime)}`;
    } else if (isSameDay) {
        return formatTime(commentTime);
    } else if (minuteDifference < 2880) {
        const yesterday = new Date(currentTime);
        yesterday.setDate(yesterday.getDate() - 1);
        if (commentTime.getDate() === yesterday.getDate() &&
            commentTime.getMonth() === yesterday.getMonth() &&
            commentTime.getFullYear() === yesterday.getFullYear()) {
            return `yesterday at ${formatTime(commentTime)}`;
        }
    } else if (minuteDifference < 525600) {
        const days = Math.floor(minuteDifference / 1440);
        return `${days} ${days > 1 ? 'days' : 'day'} ago at ${formatTime(commentTime)}`;
    } else {
        const years = Math.floor(minuteDifference / 525600);
        return `${years} ${years > 1 ? 'years' : 'year'} ago at ${formatTime(commentTime)}`;
    }
};

// Examples:
// console.log(GetTimeAgo(new Date(new Date().setHours(12, 0, 0)))); // "12:00 PM"
// console.log(GetTimeAgo(new Date(new Date().setHours(5, 0, 0) - 86400000))); // "yesterday at 05:00 AM"
